import React, { ReactElement, useState } from 'react';

import { useIsPortrait } from 'components/ProvidersContainer/ScreenOrientationProvider';
import { ButtonColorSchemes } from 'components/UniveralButtons';
import { useHistory, useParams } from 'cross-platform/react-router';

import { NHSCloseButton } from '../NHSCloseButton';

import {
  CONTINUE_BUTTON,
  EMPLOYER_OPTION,
  NHS_OPTION,
  RESEARCH_OPTION,
  TITLE,
} from './constants';
import {
  CheckCircle,
  CheckMark,
  Container,
  ContinueButton,
  NHSScrollWrapper,
  Option,
  OptionsContainer,
  OptionText,
  Title,
} from './styled';

type OptionValue = 'nhs' | 'email-research' | 'email-employer';

const OPTIONS: { value: OptionValue; label: string }[] = [
  { value: 'nhs', label: NHS_OPTION },
  { value: 'email-research', label: RESEARCH_OPTION },
  { value: 'email-employer', label: EMPLOYER_OPTION },
];

export const AccessSelectorScreen = (): ReactElement => {
  const [selected, setSelected] = useState<OptionValue | null>(null);
  const history = useHistory();
  const { productReference } = useParams<{ productReference: string }>();
  const isPortrait = useIsPortrait();

  const handleClose = (): void => {
    history.push(`/${productReference}/login`);
  };

  const handleContinue = (): void => {
    if (selected === 'nhs') {
      history.push(`/${productReference}/nhs-login/country-selector`);
    } else {
      history.push(`/${productReference}/login-screen`, {
        hideNHSButton: true,
      });
    }
  };

  return (
    <Container>
      <NHSScrollWrapper
        contentContainerStyle={{
          flexGrow: 1,
          justifyContent: 'center',
          paddingVertical: isPortrait ? 0 : 32,
        }}
      >
        <Title>{TITLE}</Title>
        <OptionsContainer>
          {OPTIONS.map(({ value, label }) => (
            <Option
              key={value}
              selected={selected === value}
              onPress={() => setSelected(value)}
            >
              <CheckCircle selected={selected === value}>
                {selected === value && <CheckMark>✓</CheckMark>}
              </CheckCircle>
              <OptionText>{label}</OptionText>
            </Option>
          ))}
        </OptionsContainer>
        <ContinueButton
          isDisabled={!selected}
          onPress={handleContinue}
          text={CONTINUE_BUTTON}
          colorScheme={ButtonColorSchemes.AltPrimary}
        />
      </NHSScrollWrapper>
      <NHSCloseButton onPress={handleClose} />
    </Container>
  );
};

export default AccessSelectorScreen;
